import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { Person } from "@domain/user/user";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { stack } from "@ui/components/layout";
import { UserView } from "@ui/components/profile/userView";

interface GroupAssociateOrganizationProps extends React.HTMLAttributes<HTMLDivElement> {
	group: Group;
}
export const GroupAssociateOrganization: React.FC<GroupAssociateOrganizationProps> = ({ group, ...htmlProps }) => {
	return group.organization ? (
		<Container {...htmlProps}>
			<div>{I18n.t(`group.${group.type}.associate_org.title`)}</div>
			<UserView user={group.organization as Person} pictureSize="M" showDescription />
		</Container>
	) : null;
};

const Container = styled(RoundedBlock)`
	padding: 30px;
	${stack(16)};
	${({ theme }) => theme.textStyles.subtitle};
	.primaryName {
		${({ theme }) => theme.textStyles.primaryBold};
	}
`;
